import React from 'react';
import { Icon } from './Icon.js';
export const IconFollowObjDownFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M8.47,9.78c.146,.146,.338,.22,.53,.22s.384-.073,.53-.22l3.25-3.25c.293-.293,.293-.768,0-1.061s-.768-.293-1.061,0l-1.97,1.97V1.75c0-.414-.336-.75-.75-.75s-.75,.336-.75,.75V7.439l-1.97-1.97c-.293-.293-.768-.293-1.061,0s-.293,.768,0,1.061l3.25,3.25Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "2", y: "11.5", width: "14", height: "4.5", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconFollowObjDownFill18.js.map